"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createRefineIdeaTool = createRefineIdeaTool;
const dist_1 = require("../../../fs/dist");
const refineIdea_1 = require("../../../app/dist/refineIdea");
const samplingAiClient_1 = require("../samplingAiClient");
const refineContext_1 = require("./refineContext");
const toolDef = {
    name: 'loom_refine_idea',
    description: 'Refine an existing Loom idea document using MCP sampling. Sharpens the problem statement, fills weak sections, bumps version.',
    inputSchema: {
        type: 'object',
        properties: {
            id: { type: 'string', description: 'Idea document id to refine' },
            context_ids: { type: 'array', items: { type: 'string' }, description: 'Optional. Additional doc IDs to inject as extra context before refining.' },
        },
        required: ['id'],
    },
};
function createRefineIdeaTool(server) {
    return {
        toolDef,
        async handle(root, args) {
            const id = args['id'];
            const contextIds = Array.isArray(args['context_ids']) ? args['context_ids'] : [];
            // Primary (agent-supplied) id → suggest-on-miss.
            const { id: canonicalId, filePath } = await (0, dist_1.resolveDocIdOrThrow)(root, id);
            // Inject the thread's Unified Context bundle (locked req first) plus any
            // caller context_ids, so refine is req-aware. IO stays in the mcp layer.
            const extraContext = await (0, refineContext_1.buildRefineExtraContext)(root, canonicalId, contextIds);
            const result = await (0, refineIdea_1.refineIdea)({ filePath, extraContext }, { loadDoc: dist_1.loadDoc, saveDoc: dist_1.saveDoc, aiClient: (0, samplingAiClient_1.samplingAiClient)(server) });
            return { content: [{ type: 'text', text: JSON.stringify(result) }] };
        },
    };
}
